
import React from 'react';
import Layout from '@/components/layout/Layout';
import HarvestCalendarTimeline from '@/components/calendar/HarvestCalendarTimeline';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { CalendarDays, ChevronLeft } from 'lucide-react';

const HarvestCalendarPage: React.FC = () => {
  return (
    <Layout>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold mb-1">Harvest Calendar</h1>
          <p className="text-muted-foreground">View upcoming harvests in a calendar timeline</p>
        </div>
        <div className="flex items-center space-x-4">
          <Button variant="outline" asChild>
            <Link to="/harvests" className="flex items-center">
              <ChevronLeft className="h-4 w-4 mr-1" />
              Back to Harvests
            </Link>
          </Button>
          <Button asChild>
            <Link to="/harvests/new" className="flex items-center">
              <CalendarDays className="h-4 w-4 mr-2" />
              Add Harvest
            </Link>
          </Button>
        </div>
      </div>
      
      <HarvestCalendarTimeline />
    </Layout>
  );
};

export default HarvestCalendarPage;
